import React from 'react';

interface DisabledFeatureMessageProps {
  featureName: string;
  message?: string;
  className?: string;
}

/**
 * Reusable component for displaying disabled feature messages
 */
export function DisabledFeatureMessage({ 
  featureName, 
  message,
  className = ""
}: DisabledFeatureMessageProps) {
  const defaultMessage = `${featureName} is temporarily disabled`;
  const displayMessage = message || defaultMessage;

  return (
    <div className={`bg-muted/50 p-4 rounded-lg border border-red-300 ${className}`}>
      <p className="text-sm text-red-600">
        {displayMessage}
      </p>
    </div>
  );
}

/**
 * Variant for larger, more prominent disabled feature messages
 */
export function DisabledFeatureMessageLarge({ 
  featureName, 
  message,
  className = ""
}: DisabledFeatureMessageProps) {
  const defaultMessage = `${featureName} is temporarily disabled`;
  const displayMessage = message || defaultMessage;

  return (
    <div className={`bg-muted/50 p-6 rounded-lg border border-red-300 text-center ${className}`}>
      <h3 className="font-medium text-foreground mb-2">{featureName}</h3>
      <p className="text-sm text-red-600">
        {displayMessage}
      </p>
    </div>
  );
} 